import axios from 'axios'

const api = axios.create({
  baseURL: '/api/users',
  headers: { 'Content-Type': 'application/json' },
})

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('user_token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

export interface User {
  user_id: string
  email: string
  name: string | null
  plan: string
  created_at: string
}

export interface UserUsage {
  plan: string
  daily_limit: number
  monthly_limit: number
  used_daily: number
  used_monthly: number
  remaining_daily: number
  remaining_monthly: number
  cache_hit_daily: number
  cache_miss_daily: number
  output_daily: number
  cache_hit_monthly: number
  cache_miss_monthly: number
  output_monthly: number
}

export interface AuthResponse {
  access_token: string
  token_type: string
  user: User
}

export const userApi = {
  register: (email: string, password: string, name?: string) =>
    api.post<AuthResponse>('/register', { email, password, name }),

  login: (email: string, password: string, remember?: boolean) =>
    api.post<AuthResponse>('/login', { email, password, remember }),

  getMe: () => api.get<User>('/me'),

  updateMe: (data: { email?: string; name?: string; password?: string }) =>
    api.put<User>('/me', data),

  deleteMe: () => api.delete('/me'),

  getUsage: () => api.get<UserUsage>('/me/usage'),
}
